
/*https://stackoverflow.com/questions/36795819/when-should-i-use-curly-braces-for-es6-import
 The default exports tend to be used for whatever you normally expect to get from the module. The named exports tend to be used for utilities that might be handy, but aren’t always necessary. However it is up to you to choose how to export things: for example, a module might have no default export at all.*/

/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Library imports */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import 'babel-polyfill';

/* Component imports */
import * as Utils from "./utility/Utility";
import PrivacyAndPolicies from './scenes/PrivacyAndPolicies/PrivacyAndPolicies';
import Faq from "./scenes/FAQ/Faq";
import FaqFreelancer from "./scenes/FAQ/FaqFreelancer";
import TermsAndConditions from "./scenes/TermsAndConditions/TermsAndConditions";

/* Style imports */
import "./styles/core_components/all_core.css";


/*** End Imports ***/
class App extends Component {

    componentDidMount () {
        setTimeout(() => {
            Utils.hidePageLoader();
        }, 2000)
    }

    render(){
        return (
                <Switch>
                    <Route path="/information/privacy-policy" component = {PrivacyAndPolicies}/>
                    <Route path="/information/terms-and-conditions" component = {TermsAndConditions}/>
                    <Route path="/information/faq" component = {Faq}/>
                    <Route path="/information/faq-freelancer" component = {FaqFreelancer}/>
                    
                </Switch>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js